import { Http } from "../utils/http.js";
class Collect extends Http {
  productCollect(param) {
    let _this = this;
    return _this.request({
      url: "WebApi/Common/ProductCollect",
      method: "post",
      param: param
    });
  }
}
export { Collect };
